const axios = require('axios');
const baseURL = 'https://923ibe72fif35b27d3fdb23.shelfperks.in';
// const baseURL = 'http://localhost:4242';

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiZ3Jvd19jbG91ZGZ1bmN0aW9uc19kZXYiLCJpYXQiOjE2NTE2MzM3MTV9.OVae4_a2AreFZ_8Wf504clbHgX6GD3tjFyjOjimUSm8";

export async function subscribeNewsLetter(value) {
    const url = baseURL + "/newsletter/insert_new_entry";
    const inputObj = {
        "inputObject": {
            "email": value['email'],
            "name": "",
            "ipv4 Address": value['ipv4_Address'],
            "ipv6 Address": value['ipv6_Address'],
            "location": value['location'],
            "userAgent": value['userAgent'],
            "date_time": new Date().toUTCString(),
            "source": "ShelfPerks",
        }
    }
    const headerObj = {
        "content-type": "application/json; charset=UTF-8",
        'x-access-token': `${token}`
    };

    const response = await axios({
        method: "post",
        url: url,
        data: inputObj,
        headers: headerObj
    })
        .then((response) => {
            return response;
        },
            (error) => {
                return error;
            });
    return response;
}

export async function premiumContactUs(value) {
    const url = baseURL + "/grow/premium_contactus";
    const inputObj = {
        "inputObject": {
            "email": value['email'],
            "name": value['business_name'],
            "contact_name": value['contact_name'],
            "phone": value['phone'],
            "monthly_sale": value['monthly_sale'],
            "number_of_locations": value['number_of_locations'],
            "number_of_staff": value['number_of_staff'],
            "number_of_pos_machines": value['number_of_pos_machines'],
            "selling_online": value['selling_online'],
            "current_software": value['current_software'],
            "any_issues": value['any_issues'].toString(),
            "priority_features": value['priority_features'].toString(),
            "spending_on_billing_software": value['spending_on_billing_software'],
            "when_to_change": value['when_to_change'],
            "ipv4 Address": value['ipv4_Address'],
            "ipv6 Address": value['ipv6_Address'],
            "location": value['location'],
            "userAgent": value['userAgent'],
            "date_time": new Date().toUTCString(),
            "source": "Grow ShelfPerks India",
        }
    }
    const headerObj = {
        "content-type": "application/json; charset=UTF-8",
        'x-access-token': `${token}`
    };

    const response = await axios({
        method: "post",
        url: url,
        data: inputObj,
        headers: headerObj
    })
        .then((response) => {
            return response;
        },
            (error) => {
                return error;
            });
    return response;
}

